<template>
 <DBox
    :addButton="false"
    :addLink="false"
    :id="'cmp-booking-promoters-promoter-communication'"
  >
      <TextField2
        :id="'phone1'"
        :placeholder="$t('phone_1')"
        :label="$t('phone_1')"
        :value="contact.phone1"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'phone2'"
        :placeholder="$t('phone_2')"
        :label="$t('phone_2')"
        :value="contact.phone2"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'email1'"
        :placeholder="$t('email_1')"
        :label="$t('email_1')"
        :value="contact.email1"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'email2'"
        :placeholder="$t('email_2')"
        :label="$t('email_2')"
        :value="contact.email2"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'chat3'"
        :placeholder="$t('skype')"
        :label="$t('skype')"
        :value="contact.chat3"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'fax1'"
        :placeholder="$t('fax')"
        :label="$t('fax')"
        :value="contact.fax1"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
      />
      <TextField2
        :id="'url1'"
        :placeholder="$t('url_1')"
        :label="$t('url_1')"
        :value="contact.url1"
        :disabled="false"
        @blur="(e) => onTextFieldValueChange(e)"
        bb="0px"
      />
 </DBox>
</template>

<script>

export default {
  components: {
    
  },
  props: ["promoterOverview"],
  data: function() {
    return {
      
    };
  },
  mounted: function() {},
  watch: {},
  computed: {
    contact: function() {
      return this.promoterOverview.contact || {};
    }
  },
  methods: {
    onTextFieldValueChange: function(event) {
      const { name, value } = event;
      this.$emit('changed', {name, value, contactID: this.contact["contact_id"]});
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
